<template>
  <div class="resultCard resultCollect">
    <div class="top">
      <div
        v-for="(item, index) in finishConfig.answer"
        :key="index"
        class="collect-wrap"
      >
        <div class="email-box collectRow" v-if="item.collectType === 'email'">
          <div class="email-icon"></div>
          <input
            type="email"
            v-model="resultCollectInfo.email"
            class="row-input email-input"
            :placeholder="$t('enterEmail')"
          />
        </div>
        <div
          class="telephone-box collectRow"
          v-if="item.collectType === 'phone'"
        >
          <div class="code-box">
            <div class="code-icon"></div>
            <select class="code-select" v-model="resultCollectInfo.phoneArea">
              <option
                :value="phoneCode"
                v-for="(phoneCode, codeIndex) in codeArr"
                :key="codeIndex"
              >
                +{{ phoneCode }}
              </option>
            </select>
          </div>
          <input
            type="tel"
            inputmode="decimal"
            class="row-input phone-input"
            v-model="resultCollectInfo.phone"
            :placeholder="$t('enterPhone')"
          />
        </div>
      </div>
    </div>
    <div class="bottom">
      <Tips
        v-if="resultState.checkTips.length"
        :tips="resultState.checkTips"
      ></Tips>
      <a href="javascript:void(0)" class="commitInfoBtn" @click="commitInfo">{{
        $t("submit")
      }}</a>
    </div>
  </div>
</template>
<script setup>
import resultHook from "@/hooks/resultHook";
import Tips from "@/components/common/Tips.vue";
const { finishConfig, checkTips, resultState, commitInfo, resultCollectInfo } =
  resultHook();

let phoneObjectConfig = finishConfig.value.answer.find(
  (item) => item.collectType === "phone"
);

let parsePhoneCodeObjectConfig = phoneObjectConfig
  ? phoneObjectConfig?.ext?.phoneCodeArr?.map((item) => JSON.parse(item))
  : [];

let codeArr = parsePhoneCodeObjectConfig.map((item, index) => {
  index === 0 &&
    resultCollectInfo.phoneArea.length === 0 &&
    (resultCollectInfo.phoneArea = item.code);
  return item.code;
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixin.scss";
.resultCollect {
  width: 100%;
  height: 100%;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  box-sizing: border-box;
  padding: 40px 40px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: auto;
  @media (orientation: landscape) {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    padding: 100px 40px 80px;
  }
  .top {
    width: 90%;
    @media (orientation: landscape) {
      width: 40%;
    }
    .collect-wrap {
      width: 100%;
      margin: 20px 0;
      @media (orientation: landscape) {
        margin: 20px 0;
      }
    }
  }
  .bottom {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .commitInfoBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    background: $btnColor;

    height: 70px;
    width: 60%;
    border-radius: 10px;
    color: #fff;
    margin-top: 20px;
    @media (orientation: landscape) {
      width: 20%;
      height: 70px;
      border-radius: 100px;
      margin-top: 20px;
    }
  }
}
</style>
